<template>
    <div>
        <h1 style="padding-top: 100px;">bbitbbitbook</h1>
        <h2>개인정보 취급방침</h2>
        <p style="text-align: left; padding: 10%;">
        'Alamofire'
        <br><br><br>
        https://github.com/Alamofire/Alamofire
        Copyright (c) 2014-2020 Alamofire Software Foundation (http://alamofire.org/)
        MIT license
        <br><br><br>
        ‘Firebase’
        <br><br><br>
        https://firebase.google.com
        Copyright (c) Google
        <br><br><br>
        'Google-Mobile-Ads-SDK'
        <br><br><br>
        https://developers.google.com/admob/ios/download
        Copyright (c) Google
        <br><br><br>
        'RealmSwift'
        <br><br><br>
        https://realm.io/realm-swift/
        © 2023 Realm
        <br><br><br>
        
        'ESTabBarController-swift'
        <br><br><br>
        https://github.com/eggswift/ESTabBarController
        Copyright (c) 2016 lihao
        <br><br><br>
        
        'MaterialComponents/BottomSheet'
        <br><br><br>
        https://m2.material.io/components/sheets-bottom/ios
        Copyright (c) Google
        <br><br><br>
        'DropDown'
        <br><br><br>
        https://github.com/AssistoLab/DropDown
        Copyright (c) 2014 kevin-hirsch
        <br><br><br>
        
        'lottie-ios'
        <br><br><br>
        https://github.com/airbnb/lottie-ios
        Copyright 2018 Airbnb, Inc.
        <br><br><br>
        
        'FLCharts'
        <br><br><br>
        https://github.com/francescoleoni98/FLCharts
        Copyright (c) 2022 Francesco Leoni
        
        <br><br><br>
        'Cards'
        <br><br><br>
        https://github.com/PaoloCuscela/Cards
        Copyright (c) 2017 PaoloCuscela
        <br><br><br>
        
        'AlignedCollectionViewFlowLayout'
        <br><br><br>
        https://github.com/mischa-hildebrand/AlignedCollectionViewFlowLayout
        Copyright (c) 2017 Mischa Hildebrand web@mischa-hildebrand.de
        <br><br><br>
        
        'Kingfisher'
        <br><br><br>
        https://github.com/onevcat/Kingfisher
        Copyright (c) 2019 Wei Wang
        <br><br><br>
        
        'GrowingTextView'
        <br><br><br>
        https://github.com/KennethTsang/GrowingTextView
        Copyright (c) 2016 Kenneth Tsang kenneth.tsang@me.com
        <br><br><br>
        
        'FSCalendar'
        <br><br><br>
        https://github.com/WenchaoD/FSCalendar
        Copyright (c) 2013-2016 FSCalendar (https://github.com/WenchaoD/FSCalendar)
        
        <br><br><br>
        'BetterSegmentedControl'
        
        https://github.com/gmarm/BetterSegmentedControl
        Copyright (c) 2016 George Marmaridis gmarmas@gmail.com
        
        <br><br><br>
        'SwiftyTimer'
        <br><br><br>
        https://github.com/radex/SwiftyTimer
        Copyright (c) 2015-2016 Radosław Pietruszewski
        <br><br><br>
        
        'IncrementableLabel'
        <br><br><br>
        https://github.com/tbaranes/IncrementableLabel
        Copyright (c) 2015 Tom Baranes
        
        <br><br><br>
        'CountdownLabel'
        <br><br><br>
        https://github.com/suzuki-0000/CountdownLabel
        Copyright (c) 2016 suzuki_keishi
        <br><br><br>
        
        'FloatRatingView'
        <br><br><br>
        https://github.com/glenyi/FloatRatingView
        Copyright (c) 2014 Glen Yi
        <br><br><br>
        2023년 4월 30일 개정
        </p> 
    </div>
</template>